import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { IconLocation } from "../../assets/icons";
import placeHolderimage from "../../assets/images/load-image.jpg";
import useLazyLoad from "./LazyImage";
function CardComplex({
  itemImgSrc,
  itemUrl,
  itemName,
  itemCity,
  reserveItemCount,
}) {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [ref, inView] = useLazyLoad({ threshold: 0.1 }); // وقتی 10% المان در viewport باشد
  return (
    <Link to={itemUrl}>
      <Card className="p-1 p-md-2 rounded-3 text-center box-shadow-sm h-100">
        <div
          ref={ref}
          style={{
            position: "relative",
            width: "100%",
            height: isMobile ? "108px" : "150px",
          }}
        >
          {/* تصویر پیش‌فرض (همیشه نمایش داده می‌شود) */}
          <img
            src={placeHolderimage}
            data-src={`${itemImgSrc}?width=200`}
            altBot={itemName}
            alt=""
            aria-hidden="true"
            className="rounded-3 mb-1 w-100"
            style={{
              display: isImageLoaded ? "none" : "block", // پس از لود عکس اصلی، مخفی می‌شود
              objectFit: "cover",
              height: "100%",
              backgroundColor: "#f5f5f5", // رنگ پس‌زمینه برای حالت Placeholder
            }}
          />

          {/* تصویر اصلی (فقط وقتی در viewport باشد لود می‌شود) */}
          {inView && (
            <>
              <img
                src={`${itemImgSrc}?width=200`}
                alt={itemName}
                className={`rounded-3 mb-1 w-100 ${
                  isImageLoaded ? "visible" : "invisible"
                }`}
                loading="lazy"
                onLoad={() => setIsImageLoaded(true)} // وقتی عکس لود شد، state را آپدیت می‌کند
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </>
          )}
        </div>
        <Card.Body className="px-0 pb-2 pb-md-2 small-svg">
          <h3 className="text-black fw-bold fs-09">{itemName} </h3>
          <div className="d-flex align-items-center justify-content-center pt-2 fs-075">
            <div>{reserveItemCount} تفریح</div>
            <div className="px-1">-</div>
            <div className="">
              <IconLocation fillColor="red" /> {itemCity}
            </div>
          </div>
        </Card.Body>
      </Card>
    </Link>
  );
}
export default CardComplex;
